import { useSearchParams } from 'hooks/useSearchParams';
import { AccountQueryKey } from 'constants/account/account-route-keys';

export const useIsImportBlockchainNft = () => {
  const { modal } =
    useSearchParams<Record<keyof typeof AccountQueryKey, string>>();

  return modal === AccountQueryKey.modal.option.IMPORT_NFTS;
};
